module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-79-min.d232107c.jpg";